import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { DurchsuchenQuerySorterConfig } from 'fa-kt.types';
import { DurchsuchenService } from '../service';

@Component({
  selector: 'fa-kt-durchsuchen-sorter',
  templateUrl: './durchsuchen-sorter.component.html',
  styleUrls: ['./durchsuchen-sorter.component.css'],
})
export class DurchsuchenSorterComponent {
  public DurchsuchenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public durchsuchen: DurchsuchenService,
  ) {
    this.DurchsuchenSorterConfig = DurchsuchenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
